module.exports = __webpack_public_path__ + "static/media/voltmill-2.2623e72f.jpg";